export const diaChiLayHang = {
  sections: {
    list: { title: '取货地址' },
    detail: { title: '取货地址' },
  },
  titles: { add: '新增取货地址', edit: '编辑取货地址' },
  columns: {
    chiNhanh: '门店',
    khoVatLy: '实体仓',
    phone: '电话',
    address: '地址',
    province: '省/市',
    district: '区/县',
    ward: '乡/镇',
    viDo: '纬度',
    kinhDo: '经度',
    viewLocation: '位置',
    default: '默认',
    note: '备注',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    status: '状态',
    onOffAction: '启停',
  },
  filter: {
    searchPlaceholder: '按地址 / 电话 / 省市搜索...',
    textDetailTitle: '详细筛选',
  },
  filters: {
    hintSection: '提示',
    hintBody: '每个项目 + 门店有独立取货地址列表，其中包含 1 个默认地址。',
    statusAll: '全部',
    defaultOnly: '仅默认',
    chiNhanhAll: '全部门店',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  actions: {
    pause: '停用',
    activate: '启用',
    viewLocation: '查看位置',
    noLocation: '暂无坐标',
  },
  messages: {
    loadError: '无法加载取货地址列表。',
    deleteSuccess: '已删除取货地址。',
    noData: '暂无取货地址。',
    listSummary: '共 {count} 条',
    saveSuccess: '已保存取货地址。',
    statusChanged: '状态已更新。',
    selectedCount: '已选 {count} 项',
    deleteSelected: '删除所选 ({count})',
    bulkDeleteConfirm: '确定删除所选的 {count} 个取货地址？',
    bulkDeleteSuccess: '已删除 {count} 个取货地址',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 项失败。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '请先选择要删除的取货地址',
  },
  form: {
    chiNhanh: '门店',
    dienThoai: '电话',
    diaChi: '详细地址',
    tinhThanh: '省 / 市',
    phuongXa: '乡 / 镇',
    viTriBanDo: '地图位置',
    chonTuBanDo: '从地图选择',
    chonViTriTitle: '在地图上选择位置',
    xacNhanViTri: '确认位置',
    viTriHienTai: '当前位置',
    xoaViTri: '清除位置',
    viDo: '纬度',
    kinhDo: '经度',
    banDoHuongDan: '点击地图或拖动标记以选择位置。',
    banDoHuongDanNgan: '尚未选择位置。点击“从地图选择”以标注坐标。',
    coordsFormat: '纬度: {viDo} · 经度: {kinhDo}',
    geoDenied: '未获得定位权限，请在浏览器中允许定位。',
    geoUnavailable: '无法获取当前位置。',
    reverseFailed: '已保存坐标。未能解析详细地址，请手动填写。',
    macDinh: '设为该门店的默认取货地址',
    ghiChu: '备注',
  },
  validation: {
    chiNhanhRequired: '请选择门店。',
  },
  placeholders: {
    formTitle: '取货地址',
    formBody: '',
    provinceEmpty: '— 选择省/市 —',
    wardEmpty: '— 选择乡/镇 —',
    addressSearch: '输入至少2个字符搜索地址',
    addressNoOptions: '无地址建议',
    viDo: '例: 10.7769',
    kinhDo: '例: 106.7009',
  },
  aria: {
    columnPicker: '选择显示列',
  },
}
